import React from 'react';
import { Check } from 'lucide-react';
import { Section, FadeIn } from './ui/Section';
export function WhoIsItFor() {
  const painPoints = ['Compras para calmarte y luego te cae la realidad.', 'Te prometes que "ya no", pero en el momento se te va la mano.', 'Evitas ver tu app del banco porque te da ansiedad.', 'Usas MSI como "analgésico" (y luego te aprieta).', 'Te duele admitirlo porque por fuera pareces alguien que "sí puede".'];
  return <Section background="warm" data-id="element-323">
      <FadeIn data-id="element-324">
        <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-12 text-center" data-id="element-325">
          Si esto te suena…{' '}
          <span className="italic text-[#C4467E]" data-id="element-326">
            eres la persona correcta
          </span>
        </h2>
      </FadeIn>

      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-327">
        {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-328">
            <div className="flex items-start p-4 bg-white/80 backdrop-blur-sm rounded-lg shadow-sm" data-id="element-329">
              <div className="flex-shrink-0 mt-1" data-id="element-330">
                <div className="w-6 h-6 rounded-full bg-[#FDE8F0] flex items-center justify-center" data-id="element-331">
                  <Check className="w-4 h-4 text-[#C4467E]" data-id="element-332" />
                </div>
              </div>
              <p className="ml-4 text-[#7A5C6B] text-lg" data-id="element-333">{point}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-334">
        <div className="mt-12 text-center bg-[#3D1F2E]/90 backdrop-blur-sm text-[#FFF5F0] p-8 rounded-2xl shadow-xl" data-id="element-335">
          <p className="text-xl md:text-2xl font-serif italic mb-4" data-id="element-336">
            Esto no se arregla con vergüenza.
          </p>
          <p className="text-lg font-medium tracking-wide uppercase" data-id="element-337">
            Se arregla con fricción + reglas claras + recompensas limpias.
          </p>
        </div>
      </FadeIn>
    </Section>;
}